// קומפוננטה שמחזירה את אותו UI כמו AllCakes, אבל עם נתוני דמה בלבד
import React from 'react';
import { SinglePie } from './SinglePie';
import { demoCakesData } from './AllCakesDemoData';

export const AllCakesDemo: React.FC<{ childName: string }> = ({ childName }) => {
  // המרה לפורמט pie
  const behaviors: { [key: string]: number } = {};
  const path: { [key: string]: number } = {};
  const response: { [key: string]: number } = {};
  let total = 0;
  demoCakesData.forEach(item => {
    behaviors[item.behavior] = item.percentage;
    path[item.path] = item.percentage;
    response[item.result] = item.percentage;
    total += item.percentage;
  });
  const convertToChartData = (dataObj: { [key: string]: number }) =>
    Object.entries(dataObj).map(([name, value]) => ({ name, value }));

  const behaviorsColors = ['#e0efbb', '#d2e0cc', '#d4ecee', '#dcc8ec', '#eec0c6', '#f8ddcd'];
  const pathColors = ['#d2e0cc', '#d4ecee', '#dcc8ec', '#eec0c6', '#f8ddcd', '#e0efbb'];
  const responseColors = ['#d4ecee', '#dcc8ec', '#eec0c6', '#f8ddcd', '#e0efbb', '#d2e0cc'];

  return (
    <div style={{ padding: '2rem', backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <h2 style={{ color: '#000000', fontSize: '2rem', marginBottom: '0.5rem' }}>
          סיכום ניתוח ההתנהגות - {childName}
        </h2>
      </div>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
        gap: '3rem',
        maxWidth: '1200px',
        margin: '0 auto',
        alignItems: 'flex-start',
        direction: 'rtl'
      }}>
        <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', minHeight: '600px' }}>
          <h3 style={{ 
            fontSize: '1.3rem', 
            color: '#000000', 
            marginBottom: '0rem',
            fontWeight: '500',
            height: '30px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            התנהגויות
          </h3>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <SinglePie title="" data={convertToChartData(behaviors)} colors={behaviorsColors} />
          </div>
        </div>
        
        <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', minHeight: '600px' }}>
          <h3 style={{ 
            fontSize: '1.3rem', 
            color: '#000000', 
            marginBottom: '0rem',
            fontWeight: '500',
            height: '30px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            נסיבות
          </h3>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <SinglePie title="" data={convertToChartData(path)} colors={pathColors} />
          </div>
        </div>
        
        <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', minHeight: '600px' }}>
          <h3 style={{ 
            fontSize: '1.3rem', 
            color: '#000000', 
            marginBottom: '0rem',
            fontWeight: '500',
            height: '30px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            תוצאות
          </h3>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <SinglePie title="" data={convertToChartData(response)} colors={responseColors} />
          </div>
        </div>
      </div>
    </div>
  );
};
